import type { FC, ReactNode } from 'react';
import { QHeading } from '..';
import { DataProps } from '../../utils';

export type QTitleProps = DataProps & {
  children?: ReactNode;
};

export const QTitle: FC<QTitleProps> = ({ children, ...rest }) => (
  <QHeading size="lg" as="h1" {...rest}>
    {children}
  </QHeading>
);

QTitle.displayName = 'QTitle';
